module.exports = __webpack_public_path__ + "static/media/loading_new.6fc3e38c.gif";